export default __webpack_public_path__ + "static/Apartamento-2b01072d1d4146cd735670a1bae68f70.jpg";